import React from 'react';

/**
 * Covers the avatar box while there is nothing worth showing: the Anam stream
 * is still connecting, or the coach is finishing a reply that is playing
 * locally. In the latter case the avatar is connected but has no audio to
 * lipsync — showing it idle over the voice reads as a broken avatar, so the box
 * keeps loading until the two are back in sync.
 *
 * The two cases look identical without a label, and the second one can last a
 * whole reply, so the message says which one the user is waiting on.
 */
function AnamAvatarLoader({ message = 'Connecting coach…' }) {
  return (
    <div
      className='absolute inset-0 z-40 flex flex-col items-center justify-center gap-3 bg-white/70'
      role='status'
      aria-label={message}
    >
      <span className='h-8 w-8 animate-spin rounded-full border-[3px] border-primary-100 border-t-brandcolora' />
      <span className='max-w-[90%] text-center text-xs font-medium text-brandcolora'>
        {message}
      </span>
    </div>
  );
}

export default AnamAvatarLoader;
